import styled from "styled-components";

export const ConfirmContainer = styled.div`
  padding: 32px 0;
  .detail {
    background:#fff;
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.19);
    overflow: hidden;
    padding: 32px;
    min-height: 100%;
    .item {
      border-bottom: 1px solid #e2e7e7;
      display: flex;
      justify-content: space-between;
      line-height: 32px;
      .value {
        color: ${({ theme }) => theme.colors.lightFont};
      }
    }
    .bold {
      padding: 12px 0;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .dealer-box {
    position: relative;
    .edit-icon {
      font-size: 24px;
      position: absolute;
      top: 16px;
      left: 16px;
      cursor: pointer;
      color: #222;
    }
    background-color: #fff;
    margin: 16px 0;
    border-radius: 10px;
    padding: 16px;
    .text,
    .province-city {
      font-weight: bold;
    }
  }
  .recaptcha {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    justify-content: space-between;
    .policy {
      display: flex;
      align-items: center;
      font-size: 14px;
      input {
        height: 20px;
        width: 20px;
        margin-left: 10px;
      }
      label {
        padding-top: 5px;
        span {
          cursor: pointer;
          color: #ca6a43;
        }
      }
    }
  }
  .buttons {
    display: flex;
    justify-content: space-between;
  }
  @media only screen and (max-width: 760px) {
    .detail {
      padding: 16px 8px;
      .item {
        line-height: 22px;
        flex-direction: column;
        font-size: ${({ theme }) => theme.sizes.fontsm};
        padding-top: 8px;
        .value {
          color: ${({ theme }) => theme.colors.lightFont};
          font-size: ${({ theme }) => theme.sizes.fontxs};
        }
      }
    }
  }
`;
